import React, { FunctionComponent } from 'react';

import * as ReachDialog from '@radix-ui/react-dialog';
import clsx from 'clsx';

import { isValueSet } from '@utils/guards';
import { applyTypograf } from '@utils/typograf';

import { ArrowBackIcon, CloseIcon } from '@components/icons';

import styles from './Dialog.module.scss';

type ClassKey = 'root' | 'overlay' | 'content' | 'close' | 'closeIcon' | 'title';

type DialogProps = {
    isOpen: boolean;
    setOpen(open: boolean): void;
    onGoBack?(): void;
    title?: string;
    isClosable?: boolean;
    isTitleTypograf?: boolean;
    classes?: Classes<ClassKey>;
};
export const Dialog: FunctionComponent<DialogProps> = (props) => {
    const {
        isOpen,
        setOpen,
        title,
        onGoBack,
        classes,
        children,
        isClosable = true,
        isTitleTypograf = true,
    } = props;

    return (
        <ReachDialog.Root open={isOpen} onOpenChange={setOpen}>
            <ReachDialog.Portal>
                <ReachDialog.Overlay className={clsx(styles.overlay, classes?.overlay)}>
                    <ReachDialog.Content className={clsx(styles.content, classes?.content)}>
                        {isClosable && (
                            <ReachDialog.Close
                                className={clsx(styles.close, classes?.close)}
                                type="button"
                            >
                                <CloseIcon className={clsx(styles.closeIcon, classes?.closeIcon)} />
                            </ReachDialog.Close>
                        )}

                        {isValueSet(title) ? (
                            <div className={styles.heading}>
                                {isValueSet(onGoBack) ? (
                                    <button
                                        type="button"
                                        onClick={onGoBack}
                                        className={styles.backButton}
                                        data-testid="dialog-back-btn"
                                    >
                                        <ArrowBackIcon className={styles.arrowBackIcon} />
                                    </button>
                                ) : null}
                                <ReachDialog.Title className={clsx(styles.title, classes?.title)}>
                                    {isTitleTypograf ? applyTypograf(title) : title}
                                </ReachDialog.Title>
                            </div>
                        ) : null}

                        {children}
                    </ReachDialog.Content>
                </ReachDialog.Overlay>
            </ReachDialog.Portal>
        </ReachDialog.Root>
    );
};
